import { applyStyles, applyPageSettings, applyDashboardSettings } from "../../Util/whitelabel"

import styles from "./styles"
import page from "./page"
import dashboard from "./dashboard"

applyStyles(styles)
applyPageSettings(page)
applyDashboardSettings(dashboard)
